import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/schedule-a-meeting")({
  beforeLoad: () => {
    throw redirect({
      href: "https://meetings.hubspot.com/torri-umb",
      statusCode: 302,
    });
  },
});
